import { Pipe, PipeTransform } from '@angular/core';
import { StudentProfile } from '../../interfaces/student';
import { ReferenceValueResponse } from 'src/app/modules/evaluations/interfaces/reason-for-delay';
@Pipe({
  name: 'uploadDocumentTypes',
  standalone: false,
})
export class UploadDocumentTypesPipe implements PipeTransform {
  transform(
    data: ReferenceValueResponse[],
    studentDetails: StudentProfile
  ): ReferenceValueResponse[] {
    if (studentDetails?.eiId === null) {
      data = data.filter(
        (x: ReferenceValueResponse) => x.description !== 'DEP-1'
      );
    }
    return data;
  }
}
